// The Post Event Analysis themes; each stores { analysis, recommendations }
// under postEventAnalysis[dbName]. Kept free of React so the report PDF can
// use it without importing the event page.
export const themes = [
  { title: 'Event Planning', dbName: 'eventPlanning' },
  { title: 'Resources', dbName: 'resources' },
  { title: 'Personnel', dbName: 'personnel' },
  { title: 'Communications', dbName: 'comms' },
  { title: 'Response Times', dbName: 'responseTimes' },
  { title: 'Build & Tear-down', dbName: 'buildTearDown' },
  { title: 'Crowd Safety', dbName: 'crowdSafety' },
  { title: 'Staff Welfare', dbName: 'staffWelfare' },
  { title: 'NHS Impact', dbName: 'nhsImpact' },
]
